import React from 'react'
import { FaMapMarkerAlt } from '@react-icons/all-files/fa/FaMapMarkerAlt'
import { AiOutlineDelete } from '@react-icons/all-files/ai/AiOutlineDelete'
import LocationAutocomplete from './LocationAutocomplete'
import styles from './CanonicalBusinessLocations.module.scss'

const addressText = location => {
  if (location?.formattedAddress) return location.formattedAddress
  if (location?.provider?.formatted_address) return location.provider.formatted_address
  const address = location?.address || {}
  const cityLine = [address.city, [address.state, address.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ')
  return [address.street, cityLine].filter(Boolean).join(', ')
}

export const locationForAutocomplete = location => location ? {
  ...location,
  formattedAddress: addressText(location),
  isVenue: location.isVenue ?? Boolean(location.name && location.name !== 'Delivery Location'),
} : null

const CanonicalBusinessLocations = ({
  disabled = false,
  locations = [],
  market = 'miami',
  onChange,
}) => {
  const rows = locations.length ? locations : [null]

  const replaceAt = (index, location) => {
    const next = [...rows]
    next[index] = location
    onChange(next)
  }

  const removeAt = index => {
    const next = rows.filter((_, rowIndex) => rowIndex !== index)
    onChange(next.length ? next : [null])
  }

  return <div className={styles.root}>
    <div className={styles.intro}>
      <span className={styles.introIcon} aria-hidden='true'><FaMapMarkerAlt /></span>
      <span>
        <strong>Verified business locations</strong>
        <small>Search by venue name or address, then choose a Google result. This keeps one shared record for each place.</small>
      </span>
    </div>

    <div className={styles.list}>
      {rows.map((location, index) => <section
        className={styles.card}
        key={`${location?._id || location?.provider?.place_id || 'new-location'}-${index}`}
      >
        <header className={styles.cardHeader}>
          <span>
            <strong>Location {index + 1}</strong>
            <small>{location?._id ? 'Existing saved location' : location?.provider?.place_id ? 'Verified Google location' : 'Select a location'}</small>
          </span>
          {(rows.length > 1 || location) && <button
            className={styles.removeButton}
            type='button'
            disabled={disabled}
            onClick={() => removeAt(index)}
            aria-label={`Remove location ${index + 1}`}
          >
            <AiOutlineDelete aria-hidden='true' />
            <span>Remove</span>
          </button>}
        </header>
        <LocationAutocomplete
          allowManualFallback={false}
          fullWidth
          disabled={disabled}
          market={market}
          selectedPlace={locationForAutocomplete(location)}
          onClear={() => replaceAt(index, null)}
          onSelect={selected => replaceAt(index, selected)}
        />
      </section>)}
    </div>

    <button
      className={styles.addButton}
      type='button'
      disabled={disabled || rows.some(location => !location)}
      onClick={() => onChange([...rows, null])}
    >
      <span aria-hidden='true'>+</span>
      Add another location
    </button>
  </div>
}

export default CanonicalBusinessLocations
